/* eslint-disable no-nested-ternary */
/* eslint-disable no-unused-vars */
/**
 * © [2022] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */

import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { closeTab } from '../../../../SharedModules/CommonUtilities/commonUtilities';
import AboutModal from './aboutModal';
import CustomSeparator from '../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';

const About = () => {
  const [isDialogOpen, setIsDialogOpen] = useState(true);
  const history = useHistory();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const closeDialog = () => {
    setIsDialogOpen(false);
    closeTab('/about', history);
  };
  return (
    <div className='tabs-container'>
      <CustomSeparator parent1='Help' parent2='About' />
      <div className='container-fluid h-100 d-flex flex-column justify-content-between py-3'>
        <AboutModal
          open={isDialogOpen}
          closeModal={() => {
            closeDialog();
          }}
          dialogTitle='About'
          okAction={() => {
            closeDialog();
          }}
        />
      </div>
    </div>
  );
};

export default About;
